import React from 'react';
import { Link } from 'react-router-dom';
import StaticPage from '../static/StaticPage';
import styles from '../static/staticPage.module.css';

const groups = [
  {
    title: 'Discover',
    links: [
      { to: '/', label: 'Home' },
      { to: '/?gender=male', label: "Men's services" },
      { to: '/?gender=female', label: "Women's services" },
      { to: '/services', label: 'Services' },
      { to: '/salons', label: 'Find salons' },
      { to: '/about', label: 'About us' },
      { to: '/contact', label: 'Contact' },
    ],
  },
  {
    title: 'Your account',
    links: [
      { to: '/profile', label: 'Profile' },
      { to: '/bookings', label: 'Bookings' },
      { to: '/cart', label: 'Cart' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { to: '/privacy', label: 'Privacy policy' },
      { to: '/terms', label: 'Terms of service' },
      { to: '/refund', label: 'Refund policy' },
    ],
  },
];

const SitemapPage = () => {
  return (
    <StaticPage
      title="Sitemap"
      subtitle="Pages on BarberShop. Search engines should use the XML sitemap at /sitemap.xml."
    >
      {groups.map((group) => (
        <section className={styles.section} key={group.title}>
          <h2>{group.title}</h2>
          <ul className={styles.sitemapList}>
            {group.links.map(({ to, label }) => (
              <li key={to}>
                <Link to={to}>{label}</Link>
              </li>
            ))}
          </ul>
        </section>
      ))}
      <section className={styles.section}>
        <h2>For search engines</h2>
        <ul className={styles.sitemapList}>
          <li>
            <a href="/sitemap.xml">XML sitemap</a>
          </li>
          <li>
            <a href="/robots.txt">robots.txt</a>
          </li>
        </ul>
      </section>
    </StaticPage>
  );
};

export default SitemapPage;
